export default __webpack_public_path__ + "static/media/commission_structure.600fee89.png";